module.exports = __webpack_public_path__ + "static/media/6.3a04b457.jpg";